import { render, staticRenderFns } from "./TipBond.vue?vue&type=template&id=589f9142&scoped=true&"
import script from "./TipBond.vue?vue&type=script&lang=js&"
export * from "./TipBond.vue?vue&type=script&lang=js&"
import style0 from "./TipBond.vue?vue&type=style&index=0&id=589f9142&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f9142",
  null
  
)

export default component.exports